import {PlayerBase} from "../../player/player.base";
import {Component, Injector, ViewChild} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, finalize, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";
import {GenericElm} from "../../player/generic.elm";

@Component({
  selector: 'app-radio',
  template: '<div #component></div>',
  styleUrls: []
})
export class GpsComponent extends PlayerBase {
  genericElm: GenericElm;
  charging = false;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        const radio = this.data.Radio[0];
        const font = radio.Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }),
      switchMap( font => this.getBattary()),
      switchMap( charging => this.getGps()),
      switchMap( pos => {
        const label = pos.coords.latitude + ", " + pos.coords.longitude;
        this.genericElm.setText(label, false, false);
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  getBattary(): Observable<any> {
    return new Observable<any>(sub => {
      (<any>navigator).getBattery().then((battery) => {
        this.charging = battery.charging;
        sub.next(battery.charging);
        sub.complete();
      });
    })
  }

  getGps(): Observable<any> {
    return new Observable<any>( sub => {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };
      navigator.geolocation.getCurrentPosition(
        pos => {
          sub.next(pos);
          sub.complete();
        },
        error => {
          debugger;
        },
        options);
    })
  }

}
